import { apiClient } from "@/api/client";
import type { ListQuery, Paginated } from "@/types/common";
import type { AccountStatus, AppUser, UserDetail } from "@/types/domain";

/** Talks to apps/admin-service (people.service.ts listUsers/userDetail/setUserStatus). */
export const usersApi = {
  /** GET /admin/users — page, limit, status, search. */
  list: (query: ListQuery & { status?: AccountStatus }) =>
    apiClient.get<Paginated<AppUser>>("/admin/users", { params: query }).then((r) => r.data),

  /** GET /admin/users/:id — includes lifetimeSpend, paidRides, recentRides. */
  getById: (id: string) => apiClient.get<UserDetail>(`/admin/users/${id}`).then((r) => r.data),

  /** PATCH /admin/users/:id/status — ADMIN/OPERATIONS only. */
  setStatus: (id: string, status: AccountStatus, reason?: string) =>
    apiClient
      .patch<AppUser>(`/admin/users/${id}/status`, { status, reason })
      .then((r) => r.data),
};
